export default __webpack_public_path__ + "static/2fa-398c553700acb224d05f5ad2f88ab60d.mp4";